module.exports = __webpack_public_path__ + "static/media/boatramp.5b53e260.svg";